import { API_LOAD_STATUS } from "constants/labels";

export const initialState = {
  requestType: {
    Load: {
      status: API_LOAD_STATUS.PENDING,
      message: "",
      errors: [],
    },
    Succeeded: false,
    Data: [],
  },
  county: {
    Load: {
      status: API_LOAD_STATUS.PENDING,
      message: "",
      errors: [],
    },
    Succeeded: false,
    Data: [],
  },
  state: {
    Load: {
      status: API_LOAD_STATUS.PENDING,
      message: "",
      errors: [],
    },
    Succeeded: false,
    Data: [],
  },
  mapRequestCreate: {
    Load: {
      status: API_LOAD_STATUS.PENDING,
      message: "",
      errors: [],
    },
    Succeeded: false,
    Data: [],
  },
  mapRequestById: {
    Load: {
      status: API_LOAD_STATUS.PENDING,
      message: "",
      errors: [],
    },
    Succeeded: false,
    Data: [],
  },
  mapRequestList: {
    Load: {
      status: API_LOAD_STATUS.PENDING,
      message: "",
      errors: [],
    },
    Succeeded: false,
    Data: [],
  },
  interactionHistory: {
    Load: {
      status: API_LOAD_STATUS.PENDING,
      message: "",
      errors: [],
    },
    Succeeded: false,
    Data: [],
  },
  mapRequestFilter: {
    Load: {
      status: API_LOAD_STATUS.PENDING,
      message: "",
      errors: [],
    },
    Succeeded: false,
    Data: [],
  },
  reviewMapRequest: {
    Load: {
      status: API_LOAD_STATUS.PENDING,
      message: "",
      errors: [],
    },
    Succeeded: false,
    Data: [],
  },
  mapRequestDropdownFilter: {
    Load: {
      status: API_LOAD_STATUS.PENDING,
      message: "",
      errors: [],
    },
    Succeeded: false,
    Data: [],
  },
  securityReviewDropdownFilter: {
    Load: {
      status: API_LOAD_STATUS.PENDING,
      message: "",
      errors: [],
    },
    Succeeded: false,
    Data: [],
  },
  status: {
    Load: {
      status: API_LOAD_STATUS.PENDING,
      message: "",
      errors: [],
    },
    Succeeded: false,
    Data: [],
  },
  mapListFilterParams: null,
};
